<template>
  <div :class="['tab-container__item tab-container__item--avatar', { active: isActive }]">
    <div class="select-edit-avatar">
      <a href="#"
         :class="[ 'avatar', { active: isFacebookActive() }, (userDetails.facebookImage) ? 'facebook_active' : 'facebook_inactive'  ]" :id="getId()">
        <span class="fb_hide">{{ getTranslations.home_profile_profile_edit_personalize_avatar_default }}</span>
        <span class="fb_show">{{ getTranslations.home_fb_facebook_avatar }}</span>
        <template v-if="userDetails.displayAvatar">
          <template v-if="userDetails.facebookImage">
            <img class="fb_show" :src="userDetails.facebookImage" alt="">
          </template>
          <div v-else>
            <img class="fb_hide" src="static/images/avatar_default.png" alt="">
          </div>
        </template>
        <template v-if="!userDetails.displayAvatar">
          <img class="fb_show" :src="userDetails.facebookImage" alt="">
        </template>
      </a>
      <a href="#" class="avatar" :data-gender="gender">
        <span>{{ getTranslations.home_profile_profile_edit_personalize_avatar_male }}</span>
        <template v-if="userDetails.displayAvatar &&  userDetails.avatarGender === gender">
          <img :src="userDetails.avatar" alt="">
        </template>
        <template v-else>
          <img :src="getImageBasedOnGender()" alt="" v-if="!isAvatarGroupWithoutAccessories">
          <img :src="provideStaticImagePerAvatarGrouping(gender)" alt="" v-else>
        </template>
      </a>
    </div>
    <avatar :gender="gender"/>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Avatar from '@/components/home/profile/Avatar';
import { initializeAvatars } from '@/common/avatarHelper';

export default {
  name: 'avatar-tab',
  props: {
    isActive: Boolean,
    gender: String,
  },
  components: {
    Avatar,
  },
  mounted() {
    const vm = this;
    this.$nextTick(() => {
      /* eslint-disable */
      initializeAvatars(vm);
    });
  },
  methods: {
    ...mapActions('common', [
      'sendAvatarCall',
      'updateDisplayAvatar',
      'sendFacebookImage',
    ]),
    provideStaticImagePerAvatarGrouping(gender) {
      return `static/images/avatar_${this.avatarGrouping.toString()}/${gender.toString()}/Avatar_1.jpg`;
    },
    getId() {
      return `default-avatar${this.gender.toString() === 'female' ? '-female' : ''}`;
    },
    getImageBasedOnGender() {
      return `static/images/avatar_personalization${this.gender.toString() === 'female' ? '_female' : ''}.png`;
    },
    isFacebookActive() {
      return (this.userAvatar === this.userDetails.facebookImage || this.userAvatar === 'static/images/avatar_default.png');
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'avatarGrouping',
      'isAvatarGroupWithoutAccessories',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/AvatarTab.vue